import { useState } from "react";
import { categories, mainSiteUrl } from "@/mocks/categories";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || submitting) return;
    setSubmitting(true);

    try {
      const formUrl = "https://readdy.ai/api/form/d8sn2f5cg4qspo1265hg";
      const formData = new URLSearchParams();
      formData.append("email", email);

      await fetch(formUrl, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formData.toString(),
      });

      setSubmitted(true);
      setEmail("");
    } catch {
      setSubmitted(true);
    } finally {
      setSubmitting(false);
    }
  };

  const col1 = categories.slice(0, 5);
  const col2 = categories.slice(5, 10);
  const col3 = categories.slice(10);

  return (
    <footer className="w-full bg-accent-50 py-14 md:py-20">
      <div className="px-6 md:px-10 lg:px-16">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="w-full lg:w-[40%]">
            <h3 className="font-heading text-2xl md:text-3xl font-black text-foreground-950 leading-[1.1] tracking-tight">
              Stay Updated<span className="block">With Kaspreadsheet</span>
            </h3>
            <p className="mt-3 text-sm text-foreground-500 max-w-md">
              Get the latest updates on mulebuy spreadsheet tools, guides, and agent shopping tips delivered to your inbox.
            </p>

            <form onSubmit={handleSubmit} className="mt-6 max-w-sm" data-readdy-form="">
              <label className="text-xs font-medium text-foreground-500 mb-1 block">
                Email Address
              </label>
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                required
                className="w-full bg-transparent border-b border-foreground-300 py-2 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-foreground-600 transition-colors"
              />
              {submitted && (
                <p className="text-xs text-accent-600 mt-2">Thanks for subscribing!</p>
              )}
              <button
                type="submit"
                disabled={submitting}
                className="mt-4 px-5 py-2 border border-secondary-300 text-secondary-700 rounded-md text-xs font-medium hover:bg-secondary-50 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-50"
              >
                {submitting ? "Subscribing..." : "Subscribe"}
              </button>
            </form>
          </div>

          <div className="w-full lg:w-[60%] grid grid-cols-3 gap-6 md:gap-8">
            <div>
              {col1.map((cat) => (
                <a
                  key={cat.seq}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="block text-sm text-foreground-600 hover:text-foreground-900 transition-colors py-1.5 cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
            <div>
              {col2.map((cat) => (
                <a
                  key={cat.seq}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="block text-sm text-foreground-600 hover:text-foreground-900 transition-colors py-1.5 cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
            <div>
              {col3.map((cat) => (
                <a
                  key={cat.seq}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="block text-sm text-foreground-600 hover:text-foreground-900 transition-colors py-1.5 cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="block text-sm font-semibold text-foreground-900 hover:text-foreground-700 transition-colors py-1.5 mt-2 cursor-pointer whitespace-nowrap"
              >
                Mulebuy Spreadsheet
              </a>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="block text-sm font-semibold text-foreground-800 hover:text-foreground-700 transition-colors py-1.5 cursor-pointer whitespace-nowrap"
              >
                Buy It Now
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} Mulebuy Spreadsheets. All external links go to Kaspreadsheet.
          </p>
          <p className="text-xs text-foreground-400">
            This is an informational SEO website. We do not own or sell products directly.
          </p>
        </div>
      </div>
    </footer>
  );
}